import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-input-loading',
	templateUrl: './input-loading.component.html',
	styleUrls: ['./input-loading.component.scss']
})
export class InputLoadingComponent implements OnInit {

	@Input() loading: boolean;
	@Input() placeholder: boolean;

	constructor() {}

	ngOnInit() {
	}

}
